export const ALLOWED_IMAGE_VIDEO_FORMATS = ['png', 'jpeg', 'jpg', 'mp4', 'mov'];
export const ALLOWED_IMAGE_FORMATS = ['png', 'jpeg', 'jpg'];
export const ALLOWED_VIDEO_FORMATS = ['mp4', 'mov'];
export const ALLOWED_AUDIO_FORMATS = ['mp3', 'aac', 'wav'];
export const AUDIO_VIDEO_FORMATS = ['mp3', 'aac', 'wav', 'mp4'];
export const ALLOWED_DOCUMENT_FORMATS = [
    'doc',
    'docx',
    'pdf',
    'xls',
    'xlsx',
    'txt',
    'csv',
    'ppt',
    'pptx',
    'zip',
    'rar',
];

export const IMAGE_VIDEO_FORMATS = ['image/png', 'image/jpeg', 'image/jpg', 'video/mp4'];
export const IMAGE_FORMATS = ['image/png', 'image/jpeg', 'image/jpg'];
export const AUDIO_FORMATS = ['audio/mp3', 'audio/wav', 'audio/mpeg', 'audio/ogg', 'audio/aac', 'audio/vnd.dlna.adts'];
export const VIDEO_FORMATS = ['video/mp4', 'video/webm', 'video/quicktime'];
export const DOCUMENT_FORMATS = [
    'application/pdf',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint',
    'text/plain',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/zip',
    'application/x-zip-compressed',
    'application/rar',
    'application/vnd.rar',
    'application/excel',
    'application/x-excel',
    'application/x-msexcel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
export const ALLOWED_ALL_FILE_FORMATS = [
    'jpg',
    'jpeg',
    'png',
    'mp3',
    'wav',
    'aac',
    'mpeg',
    'mp4',
    'doc',
    'docx',
    'pdf',
    'xls',
    'xlsx',
    'txt',
    'csv',
    'ppt',
    'zip',
    'rar',
    'pptx',
    'acc',
    'mov',
];
export const FEATURE_RESTRICTION_ERROR_MESSAGE = 'Feature unavailable for your plan';
export const CHAT_IMAGES = 'chatimages';
export const CHAT_AUDIOS = 'chataudios';
export const CHAT_VIDEOS = 'chatvideos';
export const STORY_MEDIA = 'storymedia';

export const MAX_WIDTH_WEB = 330;
export const MIN_WIDTH_WEB = 240;
export const MAX_HEIGHT_WEB = 338;
export const MIN_HEIGHT_WEB = 83;

export const MAX_WIDTH_AND = 250;
export const MIN_WIDTH_AND = 210;
export const MAX_HEIGHT_AND = 320;
export const MIN_HEIGHT_AND = 80;

export const MIN_OFFSET_WIDTH = 280;
export const MIN_OFFSET_HEIGHT = 280;

export const MIN_THUMB_WIDTH = 420;

export const PREVIEW_MEDIA_TYPES = ['image', 'video', 'audio', 'file'];
export const MEDIA_MESSAGE_TYPES = ['image', 'video', 'audio', 'file'];
export const INITIAL_LOAD_MEDIA_LIMIT = 20;
export const LOAD_MORE_MEDIA_LIMIT = 10;
export const CAPTION_CHARACTER_LIMIT = 1024;
export const STORY_CAPTION_CHARACTER_LIMIT = 350;
export const ALLOWED_KEY_CODES = [8, 35, 36, 37, 38, 39, 40, 46, 65, 67, 86];
export const TYPE_DELAY_TIME = 1000;

export const CONNECTED = 'CONNECTED';
export const INLINE_FLEX = 'inline-flex';
export const INVALID_STORENAME = 'store name is not mentioned';
export const NO_INTERNET = 'Please check your Internet connection';
export const SESSION_LOGOUT = 'The session has been logged out';
export const RECONNECT_GET_CHAT_LIMIT = 50;
export const NO_INTERNET_TOAST = 'Make sure your computer has active internet connection';
export const PROFILE_UPDATE_SUCCESS = 'Profile updated successfully';
export const INITIALS_COLOR_CODES = [
    '#9068BE',
    '#E62739',
    '#845007',
    '#3A4660',
    '#1D1E22',
    '#BE7D6A',
    '#005995',
    '#600473',
    '#CD5554',
    '#00303F',
    '#BE4F0C',
    '#4ABDAC',
    '#FC4A1A',
    '#368CBF',
    '#7EBC59',
    '#201D3A',
    '#269CCC',
    '#737272',
    '#237107',
    '#52028E',
    '#AF0D74',
    '#6CB883',
    '#0DAFA4',
    '#A71515',
    '#157FA7',
    '#7E52B1',
    '#27956A',
    '#9A4B70',
    '#FBBE30',
    '#ED3533',
    '#571C8D',
    '#54181C',
    '#9B6700',
    '#6E8E14',
    '#0752A1',
    '#BF6421',
    '#00A59C',
    '#9F0190',
    '#AE3A3A',
    '#858102',
    '#027E02',
    '#F66E54',
];
export const WALLPAPER_DEFAULT_COLOR = '';

export const WALLPAPER_COLOR_CODES = [
    '#EBEFF5',
    '#ADE4CA',
    '#CBDAEC',
    '#B0CBD1',
    '#D6D0F0',
    '#CECECE',
    '#E9E5CF',
    '#CDDBE4',
    '#E3C7FD',
    '#E7BADE',
];

export const USER_COLOR_CODES = [
    '#00A698',
    '#FF2E74',
    '#4D3266',
    '#C58730',
    '#A5B337',
    '#51A868',
    '#C5532D',
    '#B75A38',
    '#D44FA0',
    '#849DEB',
    '#7B67F6',
    '#70BBE7',
    '#259BE1',
];

export const stepsToLogin = [
    'Open Daz on your phone',
    'Tap Chats, then click scan button',
    'Switch to Scan tab',
    'Scan this code',
];

// PAGINATION LIMIT
export const CHAT_HISTORY_LIMIT = 50;
export const CHAT_HISTORY_FETCH_LIMIT = 5000;
export const RECENT_CHAT_FETCH_LIMIT = 500;
export const PARTICIPANT_BATCH_SIZE = 1000;
export const BATCH_SIZE = 10;
export const PRIVACY_STATUS_MAPPER = {
    hideProfile: 'hide_profile',
    seenReceipt: 'seen_receipt',
    lastSeen: 'hide_lastseen',
    hideOnline: 'hide_online',
};

export const privacyWithMode = [PRIVACY_STATUS_MAPPER.lastSeen, PRIVACY_STATUS_MAPPER.hideOnline];
export const MESSAGE_OPTION_TYPES = {
    REPLY: 'Reply',
    EDIT: 'Edit',
    DELETE: 'Delete',
    MESSAGE_INFO: 'MessageInfo',
    FORWARD: 'Forward',
    REPORT: 'Report',
    STARRED: 'Starred',
    UNSTARRED: 'UnStarred',
    PINNED: 'Pinned',
    UNPINNED: 'UnPinned',
    KEPT: 'Kept',
    UNKEPT: 'UnKept',
    DOWNLOAD: 'Download',
    COPY: 'Copy',
};

// Shown when the number on a shared contact card belongs to no Dazway account,
// so neither the call nor the chat action has anyone to reach.
export const CONTACT_NOT_ON_DAZWAY = 'This contact is not a Daz user';

// The one-line note a contact card shows in place of its actions.
export const CONTACT_CARD_NOTE_KEYS = {
    ok: '',
    blocked: 'chat.contactCard.CARD_BLOCKED',
    deactivated: 'chat.contactCard.CARD_DEACTIVATED',
    off: 'chat.contactCard.CARD_OFF',
};

// The fuller explanation the contact profile shows for the same states, as a
// [title, description] pair.
export const CONTACT_PROFILE_NOTE_KEYS = {
    blocked: ['chat.contactCard.BLOCKED_TITLE', 'chat.contactCard.BLOCKED_DESC'],
    deactivated: ['chat.contactCard.DEACTIVATED_TITLE', 'chat.contactCard.DEACTIVATED_DESC'],
    off: ['chat.contactCard.OFF_TITLE', 'chat.contactCard.OFF_DESC'],
};

export const CALL_MESSAGES = {
    title: {
        voice: 'Voice Call',
        video: 'Video Call',
        groupVoice: 'Group Voice Call',
        groupVideo: 'Group Video Call',
    },
    noResponse: 'No response',
    missedVoice: 'You missed a voice call',
    missedVideo: 'You missed a video call',
    missedGroupVoice: 'You missed a group voice call',
    missedGroupVideo: 'You missed a group video call',
    rejected: 'Call rejected',
    declined: 'Call declined',
    canceled: 'Call cancelled',
    silenced: 'Silenced',
    ended: 'Call ended',
    units: {
        hour: 'h',
        minute: 'm',
        second: 's',
    },
};

// busy counts as missed: the SDK answers ENGAGED for a callee who never saw the call.
export const MISSED_LIKE = ['missed', 'no_answer', 'cancelled', 'busy'];

// Positional index of each sidebar icon, matching the order of `sidenavIcons`.
export const SIDEBAR_MENU_INDEX = {
    CHATS: 0,
    CALL_LOGS: 1,
    SETTINGS: 2,
    PROFILE: 3,
};

// Menus whose right panel has no conversation to show, so it falls back to the welcome banner.
export const BANNER_ONLY_MENU_INDEXES = [SIDEBAR_MENU_INDEX.SETTINGS, SIDEBAR_MENU_INDEX.PROFILE];
